<template>
  <div
    class="tab-dropdown"
    :class="{ expanded: isExpanded }"
    :style="computedStyles"
    @click="toggleRiskLevels"
  >
    <div class="dropdown-label-container">
      <div class="dropdown-label">
        <span class="text">
          {{ (config.prefix ? config.prefix : '') + ' '
          }}{{ config.placeholder ? config.placeholder : '' }}
        </span>
        <i class="angle-down" :class="{ toggled: isExpanded }"></i>
      </div>
    </div>

    <div v-expand="isExpanded" class="options expand">
      <!-- NOSONAR -->
      <a
        v-for="(option, index) in configOptions"
        :key="option"
        :href="'#' + index"
        :style="{ fontWeight: activeTab === option.tabname ? 800 : 500 }"
        class="option"
        role="listitem"
        @click="setCurrentSelectedOption(option, index)"
        @scrolledOption="setActiveTab($event)"
      >
        {{ option.tabname }}
      </a>
    </div>
  </div>
</template>
<script>
import { EventBus } from '../../mixins/event.js';
export default {
  name: 'dropdown',
  components: {},
  directives: {
    expand: {
      inserted: function (el, binding) {
        if (binding.value !== null) {
          function calcHeight() {
            const currentState = el.getAttribute('aria-expanded');
            el.classList.add('u-no-transition');
            el.removeAttribute('aria-expanded');
            el.style.height = null;
            el.style.height = el.clientHeight + 'px';
            el.setAttribute('aria-expanded', currentState);
            el.setAttribute('role', 'list');

            setTimeout(function () {
              el.classList.remove('u-no-transition');
            });
          }
          el.classList.add('expand');
          el.setAttribute('aria-expanded', binding.value ? 'true' : 'false');
          calcHeight();
          window.addEventListener('resize', calcHeight);
        }
      },
      update: function (el, binding) {
        if (el.style.height && binding.value !== null) {
          el.setAttribute('aria-expanded', binding.value ? 'true' : 'false');
        }
      },
    },
  },
  props: ['config'],
  data() {
    return {
      activeTab: '',
      isBottomSectionToggled: false,
      optionsHeight: 0,
      optionHeight: 35,
      width: 100,
      configOptions: [],
      backgroundColor: '#cde4f5',
      backgroundExpandedColor: '#fff',
      hoverBackgroundColor: '#0084d4',
      border: '1px solid  #232b35',
      borderRadius: 0,
      textColor: '#fff',
      isExpanded: false,
    };
  },
  computed: {
    computedStyles: function () {
      return [
        { '--options-height': this.optionsHeight + 'px' },
        { '--options-height-neg': '-' + this.optionsHeight + 'px' },
        { '--option-height': this.optionHeight + 'px' },
        { '--main-el-border-radius': this.borderRadius },
        { '--dropdown-width': this.width + 'px' },
        { '--dropdown-background-color': this.backgroundColor },
        { '--dropdown-expanded-color': this.backgroundExpandedColor },
        { '--dropdown-border': this.border },
        { '--dropdown-hover-background-color': this.hoverBackgroundColor },
        { '--dropdown-default-text-color': this.textColor },
      ];
    },
  },
  created() {
    this.setConfigData();
    this.setOptionsHeight();
  },
  mounted() {
    EventBus.$on('setActiveTabEvent', (data) => {
      this.setActiveTab(data);
    });
  },
  beforeDestroy() {
    EventBus.$off('setActiveTabEvent');
  },
  methods: {
    toggleRiskLevels() {
      this.isExpanded = !this.isExpanded;
    },
    setCurrentSelectedOption(option, index) {
      this.activeTab = option.tabname;
      window.eventBus.$emit('setSelectedIndex', index);
      this.$emit('setSelectedOption', option);
    },
    setActiveTab(option) {
      this.activeTab = option.tabname;
    },
    setConfigData() {
      this.configOptions = this.config.options;
      this.width = this.config.width;
      this.placeholder = this.config.placeholder;
      if (this.config.backgroundColor) {
        this.backgroundColor = this.config.backgroundColor;
      }
      if (this.config.backgroundExpandedColor) {
        this.backgroundExpandedColor = this.config.backgroundExpandedColor;
      }
      if (this.config.border) {
        this.border = this.config.border;
      }
      if (this.config.hoverBackgroundColor) {
        this.hoverBackgroundColor = this.config.hoverBackgroundColor;
      }
      if (this.config.textColor) {
        this.textColor = this.config.textColor;
      }
      if (this.config.borderRadius) {
        this.borderRadius = this.config.borderRadius;
      }
    },
    setOptionsHeight() {
      this.optionsHeight = this.optionHeight * this.configOptions.length;
    },
  },
  beforeUdate() {},
};
</script>
